var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopUpBankOptionsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.484,
    height: 45.129,
    viewBox: "0 0 45.484 45.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 1.805,
    cy: 1.805,
    r: 1.805,
    transform: "translate(20.912 7.923)",
    fill: "#66cd78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M43.708,470H1.777a1.777,1.777,0,0,0,0,3.553H43.708a1.777,1.777,0,0,0,0-3.553Z",
    transform: "translate(0 -428.424)",
    fill: "#66cd78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M45.484,13.1a1.777,1.777,0,0,0-1.056-1.624L23.419,2.152a1.776,1.776,0,0,0-1.444,0L1.053,11.481A1.777,1.777,0,0,0,0,13.1v4.708c0,.015,0,.029,0,.044s0,.029,0,.044a1.777,1.777,0,0,0,1.777,1.777,1.582,1.582,0,0,1,1.51,1.777V38.024c0,.037,0,.074.006.11s-.006.073-.006.11a1.777,1.777,0,0,0,1.777,1.777H40.6a1.777,1.777,0,0,0,0-3.553h-5.33V21.454a1.777,1.777,0,1,1,3.553,0v7.864a1.777,1.777,0,0,0,3.553,0V21.454c0-.417.1-1.777,1.333-1.777A1.777,1.777,0,0,0,45.484,17.9c0-.015,0-.029,0-.044s0-.029,0-.044ZM10.394,36.468H6.84V21.454a1.777,1.777,0,0,1,3.553,0Zm7.107,0H13.947V21.454a1.777,1.777,0,0,1,3.553,0Zm7.107,0H21.054V21.454a1.777,1.777,0,0,1,3.553,0Zm7.107,0H28.161V21.454a1.777,1.777,0,0,1,3.553,0ZM41.931,16.035H3.553V14.257L22.7,5.721l19.231,8.538Z",
    transform: "translate(0 -1.999)",
    fill: "#66cd78"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpBankOptionsLogo);
export default __webpack_public_path__ + "static/media/TopUpBankOptionsLogo.4cdf8b45240d230d17ce3777cbd509a1.svg";
export { ForwardRef as ReactComponent };